<script setup lang="ts">
import type {LocationResponse} from "../../../responses/LocationResponse.ts";
import type {ProductResponse} from "../../../responses/ProductResponse.ts";
import Carousel from "../../ui/carousel/Carousel.vue";
import CarouselContent from "../../ui/carousel/CarouselContent.vue";
import CarouselItem from "../../ui/carousel/CarouselItem.vue";
import type {CarouselProps} from "../../ui/carousel/interface.ts";
import PreventInteraction from "../PreventInteraction.vue";
import CarouselNext from "./CarouselNext.vue";
import CarouselPrevious from "./CarouselPrevious.vue";
import Product from "./Product.vue";

interface Props {
    products: ProductResponse[],
    location?: string,
    showImage?: boolean,
    inlineNavigation?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
    showImage: true,
    inlineNavigation: false,
    location: null,
});

const carouselOpts: CarouselProps = {
    opts: {
        align: 'start',
        loop: false,
        dragFree: false,
    },
    plugins: []
};
</script>

<template>
    <Carousel
        :opts="carouselOpts.opts"
        :plugins="carouselOpts.plugins"
        class="w-full px-3 lg:px-0"
    >
        <div class="hidden lg:flex gap-2 mb-4 justify-self-end mr-4" v-if="products.length > 3 && !inlineNavigation">
            <CarouselPrevious/>
            <CarouselNext />
        </div>
        <CarouselContent class="flex">
            <CarouselItem
                v-for="(product, index) in products"
                :key="index"
                class="basis-full sm:basis-1/2 lg:basis-1/3 shrink-0 px-3 lg:pl-4"
            >
                <prevent-interaction>
                    <Product
                        class="h-full"
                        :product="product"
                        :show-image="showImage"
                        :location="location"
                    ></Product>
                </prevent-interaction>
            </CarouselItem>
        </CarouselContent>

        <CarouselPrevious v-if="inlineNavigation && products.length > 3" class="absolute -left-3 lg:-left-8 top-1/2 -translate-y-1/2" />

        <CarouselNext v-if="inlineNavigation && products.length > 3" class="absolute -right-3 lg:-right-8 top-1/2 -translate-y-1/2" />
    </Carousel>
</template>
